// extracted by mini-css-extract-plugin
export default {"facebookShareButton":"Gl6_8s","shareButton":"jhMkvw","icon":"Fnc9Ip","label":"e9pnNF"};